var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RadioTags',{attrs:{"options":_vm.operationTypeList,"name":"deal-type"},model:{value:(_vm.operationType),callback:function ($$v) {_vm.operationType=$$v},expression:"operationType"}})}
var staticRenderFns = []

export { render, staticRenderFns }